import { toast } from "react-toastify";
import store from "../../store";
import { setLoading } from "../../store/slices/commonSlice";
import {
  setBenefitsData,
  setInsuranceData,
} from "../../store/slices/insurance/insuranceSlice";
import api from "../../utils/interface";
import qs from "qs";

export const getAllProductVariants = (
  productId,
  filterValues,
  sortField,
  sortType,
  pageNumber = 0,
  pageSize = 10,
  oemIds
) => {
  store.dispatch(setLoading(true));
  const bodyData = { ...filterValues };

  let url = `/product/getAllProductVariants`;
  if (sortField && sortType) {
    url += `?sortField=${sortField}&sortType=${sortType}`;
  }

  return api
    .post(url, bodyData, {
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        productId: productId,
        page: pageNumber,
        size: pageSize,
        oem_ids: oemIds,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    })
    .then((response) => {
      if (response && response.status === 200) {
        const {
          content,
          pageable,
          totalPages,
          totalElements,
          product_benefit,
        } = response.data;

        store.dispatch(
          setInsuranceData({
            insuranceData: { content, pageable, totalPages, totalElements },
            currentPage: pageNumber,
            pageSize: pageSize,
          })
        );
        store.dispatch(setBenefitsData(product_benefit));

        return response.data;
      }
    })
    .catch((error) => {
      toast.error(error.response?.data?.error_message || "An error occurred");
    })
    .finally(() => {
      store.dispatch(setLoading(false));
    });
};
